// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__2ZrNd","addWidgetButton":"Header_addWidgetButton__3Wd4i","dashboardTabs":"Header_dashboardTabs__zoxRi","active":"Header_active__1eJi9"};